import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimals'
})
export class DecimalsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    if (value) {
      if (parseFloat(value)) {
        if (args[0][1][0]) {
          switch (args[0][1][0]) {
            case 'pretty':
              if ((value === 0) || (value === 100)) {
                return value.toFixed(0);
              }
            return value.toFixed(args[0]);
          }
        } else {
          return value.toFixed(args[0]);
        }
      }
    }
    return value;
  }

}
